import type { WritableSignal } from '@angular/core';
import type { ITableConfig } from '@tecalisdev/infinity';

function isWritableSignal(value: unknown): value is WritableSignal<unknown> {
  return typeof value === 'function' && typeof (value as WritableSignal<unknown>).set === 'function';
}

const TABLE_CONFIG_SIGNAL_KEYS = ['tableConfig', 'lotesTableConfig'] as const;

/** Señales booleanas de overlay/spinner que pueden quedar activas al desacoplar el listado. */
const SPINNER_SIGNAL_KEYS = [
  'loading',
  'openingCuentaDetail',
  'facturadorApiSpinner',
  'facturadorFacturacionSpinner',
  'facturadorApiEnCurso',
  'mutationPending',
  'eliminandoRol',
  'eliminandoUsuario',
  'eliminandoFamilia',
  'eliminandoContrato',
  'procesandoAccionMasiva',
  'eliminandoArticulo',
  'actualizandoActivo',
] as const;

function resetBooleanSignal(record: Record<string, unknown>, key: string): void {
  const signalRef = record[key];
  if (isWritableSignal(signalRef)) {
    signalRef.set(false);
  }
}

/**
 * Restaura UI de listado tras reattach (RouteReuseStrategy).
 * Evita spinner/skeleton atascados sin repetir la búsqueda HTTP.
 */
export function syncCachedListUiAfterReattach(instance: unknown): void {
  if (!instance || typeof instance !== 'object') {
    return;
  }

  const record = instance as Record<string, unknown>;

  for (const key of SPINNER_SIGNAL_KEYS) {
    resetBooleanSignal(record, key);
  }

  for (const key of TABLE_CONFIG_SIGNAL_KEYS) {
    const tableConfig = record[key];
    if (!isWritableSignal(tableConfig)) {
      continue;
    }
    (tableConfig as WritableSignal<ITableConfig>).update((cfg) => ({
      ...cfg,
      loading: false,
    }));
  }
}
